<template>
  <v-container>
    <v-row> </v-row>
    <v-row>
      <v-col cols="2">
        <v-btn
          color="red"
          dark
          @click="generateError()"
          :loading="generateErrorLoading"
        >
          Generate Error
        </v-btn>
      </v-col>
      <v-col cols="2">
        <v-btn
          color="purple"
          dark
          @click="generateCritical()"
          :loading="generateCriticalLoading"
        >
          Generate Critical
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      generateErrorLoading: false,
      generateCriticalLoading: false,
    };
  },
  mounted() {
    this.enteredMainTab();
  },
  methods: {
    enteredMainTab() {
      console.log("burny! enteredMainTab");
    },
    generateError() {
      this.generateErrorLoading = true;
      console.log(
        "burny! this.$store.state.token: " + this.$store.state.token,
      );
      this.$http
        .post(
          this.$consts.BE_ADDRESS + "/admin/generateError",
          {
            dusi: this.$store.getters.getDusi,
          },
          {
            headers: {
              Authorization: this.$store.state.token,
            },
          },
        )
        .then((response) => {
          if (response.status === 200) {
            this.$emit("notify", "Error generated", false);
            return;
          }
          this.$utils.handleKnownRespCodes(this, response.status);
        })
        .catch((error) => {
          const errMsg = this.$utils.getErrorMsg(error);
          this.$emit("notify", "Error: " + errMsg, true);
        })
        .finally(() => {
          this.generateErrorLoading = false;
        });
    },
    generateCritical() {
      this.generateCriticalLoading = true;
      this.$http
        .post(
          this.$consts.BE_ADDRESS + "/admin/generateCritical",
          {
            dusi: this.$store.getters.getDusi,
          },
          {
            headers: {
              Authorization: this.$store.state.token,
            },
          },
        )
        .then((response) => {
          if (response.status === 200) {
            this.$emit("notify", "Critical generated", false);
            return;
          }
          this.$utils.handleKnownRespCodes(this, response.status);
        })
        .catch((error) => {
          const errMsg = this.$utils.getErrorMsg(error);
          this.$emit("notify", "Error: " + errMsg, true);
        })
        .finally(() => {
          this.generateCriticalLoading = false;
        });
    },
  },
};
</script>
